// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"a2c79c7e7d--breadcrumbs--y3Ce2","link":"a2c79c7e7d--link--w8Mu2","link-light":"a2c79c7e7d--link-light--goSm7","link_wrapper":"a2c79c7e7d--link_wrapper--wNuAR"};